const ADDRESS_LINE1_REGEX = /^(([ A-Za-z0-9\\-\\_\\.\\:\\,\\'\\&\\#\\/\\\\]|(&amp;))+)$/; // ADDRESS_LINE_REGEX
const ADDRESS_LINE2_REGEX = /^(([ ]*)|([ A-Za-z0-9\\-\\_\\.\\:\\,\\'\\&\\#\\/\\\\]|(&amp;))+)$/;
const ADDRESS_STREET_OR_CITY = /^[A-Za-z0-9][ A-Za-z0-9-_.,'&@]*[A-Za-z0-9-_.,'&@]$/ // ADDRESS_STREET_OR_CITY
const NAME_REGEX = /^[A-Za-z0-9]+[ A-Za-z0-9-_.,'&]*$/;
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // EMAIL
const zipRegex = /^[0-9]*$/;

const accountNumberRegex = /^(([ ]*)|([ 0-9a-zA-Z_-]+))$/

export const beaconPattern = {
  nameRegex: '^[A-Za-z0-9]+[ A-Za-z0-9-_.,\'&]*$',
  addressOneRegex: '^(([ A-Za-z0-9\\-\\_\\.\\:\\,\\\'\\&\\#\\/\\\\]|(&amp;))+)$',
  addressTwoRegex: '^(([ ]*)|([ A-Za-z0-9\\-\\_\\.\\:\\,\\\'\\&\\#\\/\\\\]|(&amp;))+)$',
  addressCityRegex: '^[A-Za-z0-9][ A-Za-z0-9-_.,\'&@]*[A-Za-z0-9-_.,\'&@]$',
  accountNumberRegex: '^(([ ]*)|([ 0-9a-zA-Z_-]+))$',
  numberOnlyRegex: '^[0-9]*$',
  phoneNumberRegex: /^\+1 \(\d{3}\) \d{3}-\d{4}$/,
  emailRegex: '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@(([[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
}

export const isFieldRequired = (field) => {
  return field.length > 0
}

export const isValidMiddleName = (name) => {
  return name && name.trim().length >= 1 && NAME_REGEX.test(name.trim())
}

export const isValidName = (name) => {
  return name && name.trim().length >= 2 && NAME_REGEX.test(name.trim())
}

export const isRequiredValidName = (name) => {
  return isFieldRequired(name) && isValidName(name)
}

export const isValidRequiredUsPhoneNumber = (phone) => {
  if (phone) {
    if (phone.startsWith('+')) {
      return phone.length === 17;
    } 
    return phone.length === 11 && /^\d{11}$/.test(phone);
    
  }
  return false;
};

export const isValidNonUSPhoneNumber = (phoneNumber) => {
  return phoneNumber && phoneNumber.length <= 12
}

export const isRequiredValidUsAndNonUsPhoneNumber = (phone) => {
  return isFieldRequired(phone) && isValidRequiredUsPhoneNumber(phone)
}

export const isValidAddressOne = (address) => {
  return address && address.length <= 35 && ADDRESS_LINE1_REGEX.test(address)
}

export const isValidAddressTwo = (address) => {
  return !address || (address && address.length <= 35 && ADDRESS_LINE2_REGEX.test(address))
}

export const isValidCity = (city) => {
  return city && city.length <= 35 && ADDRESS_STREET_OR_CITY.test(city)
}

export const isValidZip = (zip) => {
  return zip && zip.length === 5 && zipRegex.test(zip)
}

export const isValidRequiredAccountNumber = (accountNumber) => {
  return accountNumber && isFieldRequired(accountNumber) && accountNumber.length >= 2 && accountNumberRegex.test(accountNumber)
}

export const isRequiredValidAddress = (addressMilitary, addressOne, addressTwo, addressCity, addressState, addressZip) => {
  return isFieldRequired(addressOne) && isFieldRequired(addressCity) && isFieldRequired(addressState) && isFieldRequired(addressZip) && isValidAddressOne(addressOne) && isValidAddressTwo(addressTwo) && (!addressMilitary ? isValidCity(addressCity) : true) && isValidZip(addressZip)
}

export const isValidDOB = (DOB) => {
  return DOB && isFieldRequired(DOB) && new Date() > new Date(DOB);
}

export const isValidTaxId = (SSN) => {
  return !SSN || SSN.length === 9
}

export const isRequiredValidSSN = (SSN) => {
  return isFieldRequired(SSN) && isValidTaxId(SSN)
}

export const isValidEmail = (email) => {
  return !email || (email && email.length > 0 && emailRegex.test(email))
}
